import tmhRequest from '@/config/tmhRequest'

export default {
  searchItem: function (data) {
    return tmhRequest({
      url: '/project/tmh/item/searchitem',
      method: 'post',
      params: data,
    })
  },
  searchListItem: function (data) {
    return tmhRequest({
      url: '/project/tmh/item/searchlistitem',
      method: 'post',
      params: data,
    })
  },
  searchNoPlusItem: function (data) {
    return tmhRequest({
      url: '/project/tmh/item/searchnoplusitem',
      method: 'post',
      params: data,
    })
  },
  searchItemCount: function (data) {
    return tmhRequest({
      url: '/project/tmh/item/searchitemcount',
      method: 'post',
      params: data,
    })
  },
  searchItemByPage: function (data) {
    return tmhRequest({
      url: '/project/tmh/item/searchitembypage',
      method: 'post',
      params: data,
    })
  },
  addItem: function (data) {
    return tmhRequest({
      url: '/project/tmh/item/additem',
      method: 'post',
      data: data,
    })
  },
  editItem: function (data) {
    return tmhRequest({
      url: '/project/tmh/item/edititem',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/item.js